// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"io","controlPlay":"ip","controlElement":"iq","lowerControlWrapper":"ir","lowerControlIconWrapper":"is","lowerControlIcon":"it","show":"iu"};